import { render, staticRenderFns } from "./AddInsurance.vue?vue&type=template&id=dbb7ad68&scoped=true&"
import script from "./AddInsurance.vue?vue&type=script&lang=js&"
export * from "./AddInsurance.vue?vue&type=script&lang=js&"
import style0 from "./AddInsurance.vue?vue&type=style&index=0&id=dbb7ad68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb7ad68",
  null
  
)

export default component.exports